// extracted by css-extract-rspack-plugin
export default {"topMargin":"top-margin--pLpZeQpNyZ4sqJaF","topMarginSmall":"top-margin-small--M27YCz6dbuw2gF8S","bottomMargin":"bottom-margin--r3imZAR9L8aXiakR"};